import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';
import { IErknmAgreementTerminate } from 'APIPackage/KnmModule/interfaces/IErknmAgreementTerminate';
import { ITerminationReasonSelectOption } from 'CorePackage/CatalogsModule/interfaces/ITerminationReasonSelectOption';

import { IErknmFormAgreementTerminate } from '../interfaces/IErknmFormAgreementTerminate';

export const convertAgreementsTerminateFormValuesToData = (
  terminate: IErknmFormAgreementTerminate | undefined,
): IErknmAgreementTerminate | null => {
  if (!terminate) return null;

  return {
    terminationReasons:
      (terminate.terminationReasons
        ?.map(terminationReason => terminationReason)
        .filter(i => !!i) as ITerminationReasonSelectOption[]) || null,
    decisionTerminationAttachment:
      convertKnmDocumentAttachmentsFormValuesToKnmData(terminate.decisionTerminationAttachment)?.pop() || null,
    prosecutorOrganization: {
      id:
        !terminate.prosecutorOrganization?.ervkUuid && terminate.prosecutorOrganization?.id
          ? terminate.prosecutorOrganization?.id
          : null,
      code: null,
      name: terminate.prosecutorOrganization?.fullName || null,
      address: null,
      contacts: null,
      federalDistrictId: null,
      regionId: null,
      parentId: null,
      enabled: null,
      ervkUuid: terminate.prosecutorOrganization?.ervkUuid,
      ervkVersionUuid: terminate.prosecutorOrganization?.ervkVersionUuid,
    },
    fioSigner: terminate.fioSigner?.trim() || null,
    titleSigner: terminate.titleSigner?.value || null,
    whoMadeDecision: terminate.whoMadeDecision || null,
  };
};
